/**
 * Permission constants matching backend Permissions enum.
 * Used for consistent permission checking across the frontend.
 *
 * ==================================================================================
 * WHEN TO USE THIS FILE:
 * ==================================================================================
 * Import PERMISSIONS constants whenever you need to check specific permissions:
 *
 * Examples:
 *   import { PERMISSIONS } from '../utils/permissions';
 *
 *   // Check single permission
 *   canBusiness(PERMISSIONS.ADMIN)
 *
 *   // Check project permission
 *   canProject(projectId, PERMISSIONS.DEFICIENCY_WRITE)
 *
 * Import ANY_BUSINESS_PERMISSION when you need to check if user has ANY business permission:
 *
 * Examples:
 *   import { ANY_BUSINESS_PERMISSION } from '../utils/permissions';
 *
 *   // Check if user has any business permission (for Settings access)
 *   canAnyBusiness(ANY_BUSINESS_PERMISSION)
 *
 * ==================================================================================
 * IMPORTANT: Use constants, not strings
 * ==================================================================================
 *    canBusiness(PERMISSIONS.ADMIN)
 *    canBusiness('ADMIN')  // Don't use string literals typos won't be caught
 * ==================================================================================
 */
export const PERMISSIONS = {
    // Business-scoped permissions
    BUSINESS_READ: 'BUSINESS_READ',
    BUSINESS_QR_CODE_READ: 'BUSINESS_QR_CODE_READ',
    BUSINESS_WRITE: 'BUSINESS_WRITE',
    USER_READ: 'USER_READ',
    USER_WRITE: 'USER_WRITE',
    ADMIN: 'ADMIN',
    VIEW_USAGE_DASHBOARD: 'VIEW_USAGE_DASHBOARD',

    // Project-scoped permissions
    DEFICIENCY_READ: 'DEFICIENCY_READ',
    DEFICIENCY_WRITE: 'DEFICIENCY_WRITE',
    DEFICIENCY_HISTORY_READ: 'DEFICIENCY_HISTORY_READ',
    PROJECT_READ: 'PROJECT_READ',
    PROJECT_WRITE: 'PROJECT_WRITE',
    PROJECT_MEMBERSHIP_READ: 'PROJECT_MEMBERSHIP_READ',
    PROJECT_MEMBERSHIP_WRITE: 'PROJECT_MEMBERSHIP_WRITE',
    IMAGE_READ: 'IMAGE_READ',
    IMAGE_WRITE: 'IMAGE_WRITE',
    CLOSEOUT_DOCS_READ: 'CLOSEOUT_DOCS_READ',
    CLOSEOUT_DOCS_WRITE: 'CLOSEOUT_DOCS_WRITE',
    REPORTS_READ: 'REPORTS_READ',
    FIELD_WORKER_REQUEST_READ: 'FIELD_WORKER_REQUEST_READ',
    FIELD_WORKER_REQUEST_WRITE: 'FIELD_WORKER_REQUEST_WRITE',
    FIELD_WORKER_REQUEST_REVIEW: 'FIELD_WORKER_REQUEST_REVIEW',
};

/**
 * Array of all business-level permissions.
 * Used to check if user has any business permission (e.g., for Settings nav visibility).
 */
export const ANY_BUSINESS_PERMISSION = [
    PERMISSIONS.USER_READ,
    PERMISSIONS.USER_WRITE,
    PERMISSIONS.BUSINESS_READ,
    PERMISSIONS.BUSINESS_QR_CODE_READ,
    PERMISSIONS.BUSINESS_WRITE,
    PERMISSIONS.ADMIN,
];
